/* Styles */
import "@/scss/main.scss";
import "@/css/main.css";
/* Core */
import Vue from "vue";
import Buefy from "buefy";

/* Router & Store */
import router from "./router";
import store from "./store";

/* Service Worker */
import "./registerServiceWorker";
import VueApexCharts from "vue-apexcharts";
/* Vue. Main component */
import App from "./App.vue";
import CookieConsent from "./components/CookieConsent.vue";
import VueFlags from "@growthbunker/vueflags";
import CountryFlag from "vue-country-flag";

/* Keycloak Adapter */
import Keycloak from "keycloak-js";

import env from "@/environment/env.json";

/* Default title tag */
const defaultDocumentTitle = "Circul8 EPR";

/* Keycloak inital config, you can get this data from clients added in keycloak admin console*/
const initOptions = {
  url: env.keycloakUrl,
  realm: env.keycloakRealm,
  clientId: env.keycloakClientId
};

const keycloak = Keycloak(initOptions);

/* Collapse mobile aside menu on route change & set document title from route meta */
router.afterEach(to => {
  store.commit("asideMobileStateToggle", false);

  if (to && to.meta && to.meta.title) {
    document.title = `${to.meta.title} — ${defaultDocumentTitle}`;
  } else {
    document.title = defaultDocumentTitle;
  }
});

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.use(Buefy);
Vue.use(VueFlags, {
  // Specify the path of the folder where the flags are stored.
  iconPath: "/assets/country_flags/"
});

Vue.component("country-flag", CountryFlag);
Vue.component("apexchart", VueApexCharts);
if (localStorage.getItem("CookieConcent") != "True") {
  new Vue({
    el: "#app",
    router,
    render: h => h(CookieConsent)
  });
} else {
  // keycloak init checks whether the user is logged in or not
  let vm: any;
  keycloak
    .init({ onLoad: "login-required" })
    .then(auth => {
      if (!auth) {
        window.location.reload();
      } else {
        vm = new Vue({
          router,
          store,
          render: h => h(App, { props: { keycloak: keycloak } })
        }).$mount("#app");

        // emit signal to handle storage of access tokens in App.vue
        vm.$emit("storeTokens");
      }

      // Token Refresh
      // As access token is valid for 15 mins (configured in keycloak realm token settings), this updateToken method is triggered every
      // 180000 milliseconds (3 minutes) to check the expiry of access token and if token expiry is within 180 seconds (minValidity) then
      // the token is refreshed to maintain user session
      setInterval(() => {
        keycloak
          .updateToken(180)
          .then(refreshed => {
            if (refreshed) {
              // token refreshed, update access token in local storage
              vm.$emit("storeTokens");
            }
          })
          .catch(() => {
            console.error("Failed to refresh token");
            store.commit("setKeycloakDown", {
              isDown: true,
              message:
                "Failed to refresh authentication token. Please reload the page."
            });
          });
      }, 1000);
    })
    .catch(error => {
      console.error("Keycloak initialization failed:", error);

      const errorMessage =
        "We’re experiencing some technical difficulties at the moment. Our team is on it and we’ll have the site back up and running shortly.\n\nThank you for your patience.";

      // Show alert dialog
      import("buefy").then(Buefy => {
        Vue.use(Buefy.default);

        Vue.prototype.$buefy.dialog.alert({
          title: "Authentication Error",
          message: errorMessage,
          type: "is-danger",
          hasIcon: true,
          icon: "alert-circle",
          ariaRole: "alertdialog",
          ariaModal: true,
          onConfirm: () => {
            // Reload the page to try again
            window.location.reload();
          }
        });
      });
    });
}

// meking keycloak object global to make it available in every vue instance
Vue.prototype.$keycloak = keycloak;
